import bryceCanyonLogo from "../images/bryce-canyon.png"
import bigBendLogo from "../images/big-bend.png"
import dryTortugasLogo from "../images/dry_tortugas_2.png"
import smokyMountains from "../images/great-smoky-mountains.png"
import mountRanier from "../images/mount-ranier.png"
import indianaDunes from "../images/indiana_dunes_2.png"
import acadiaLogo from "../images/acadia-logo.png"
import archesLogo from "../images/arches-logo.png"
import badlandsLogo from "../images/badlands-logo.png"
import biscayneLogo from "../images/biscayne-logo.png"
import blackCanyonLogo from "../images/black-canyon-logo.png"
import canyonlandsLogo from "../images/canyonlands-logo.png"
import capitalReefLogo from "../images/capital-reef-logo.png"
import carlsbadCavernsLogo from "../images/carlsbad-caverns-logo.png"
import channelIslandLogo from "../images/channel-island-logo.png"
import craterLakeLogo from "../images/crater-lake-logo.png"
import americanSamoaLogo from "../images/american-samoa-logo.png"
import congareeLogo from "../images/congaree-logo.png"
import cuyahogaValleyLogo from "../images/cuyahoga-valley-logo.png"
import deathValley from "../images/death-valley-logo.png"
import denali from "../images/denali-logo.png"
import everglades from "../images/everglades-logo.png"
import gatesOfTheArctic from "../images/gates-of-the-arctic-logo.png"
import gatewayArch from "../images/gateway-arch-logo.png"
import  glacierBay from "../images/glacier-bay-logo.png"
import glacier from "../images/glacier-logo.png"
import grandCanyon from "../images/grand-canyon-logo.png"
import grandTeton from "../images/grand-teton-logo.png"
import greatBasin from "../images/great-basin-logo.png"
import greatSandDunes from "../images/great-sand-dunes-logo.png"
import guadalupeMountains from "../images/guadalupe-mountains-logo.png"
import haleakala from "../images/haleakala-logo.png"
import hawaiiVolcanoes from "../images/hawaii-volcanos-logo.png"
import hotsprings from "../images/hotsprings-logo.png"
import isleRoyale from "../images/isle-royale-logo.png"
import joshuaTree from "../images/joshua-tree-logo.png"
import katmai from "../images/katmai-logo.png"
import kenaiFjords from "../images/kenai-fjords-logo.png"
import kingsCanyon from "../images/kings-canyon-logo.png"
import kobukValley from "../images/kobuk-valley-logo.png"
import lakeClark from "../images/lake-clark-logo.png"
import lassenVolcanic from "../images/lassen-volcanic-logo.png"
import mammothCave from "../images/mammoth-cave-logo.png"
import mesaVerde from "../images/mesa-verde-logo.png"
import newRiverGorge from "../images/new-river-gorge-logo.png"
import northCascades from "../images/north-cascades-logo.png"
import olympic from "../images/olympic-logo.png"
import petrifiedForest from "../images/petrified-forest-logo.png"
import redwood from "../images/redwood-logo.png"
import pinnacles from "../images/pinnacles-logo.png"
import rockyMountain from "../images/rocky-mountain-logo.png"
import saguaro from "../images/saguaro-logo.png"
import sequoia from "../images/sequoia-logo.png"
import shenandoah from "../images/shenandoah-logo.png"
import theodoreRoosevelt from "../images/theodore-roosevelt-logo.png"
import virginIslands from "../images/virgin-islands-logo.png"
import voyageurs from "../images/voyageurs-logo.png"
import whiteSands from "../images/white-sands-logo.png"
import  windCave from "../images/wind-cave-logo.png"
import wrangell  from "../images/wrangell-logo.png"
import  yellowStone from "../images/yellowstone-logo.png"
import yosemite  from "../images/yosemite-logo.png"
import zion from "../images/zion-logo.png"

export const nationalParks = [
    {
        name: "Acadia National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: acadiaLogo,
        state: "Maine"
    },
    {
        name: "Arches National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: archesLogo,
        state: "Utah"
    },
    {
        name: "Badlands National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: badlandsLogo,
        state: "South Dakota"
    },
    {
        name: "Big Bend National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: bigBendLogo,
        state: "Texas"
    },
    {
        name: "Biscayne National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: biscayneLogo,
        state: "Florida"
    },
    {
        name: "Black Canyon of the Gunnison",
        boundary: null,
        trails: null,
        grow: 1,
        logo: blackCanyonLogo,
        state: "Colorado"
    },
    {
        name: "Bryce Canyon National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: bryceCanyonLogo,
        state: "Utah"
    },
    {
        name: "Canyonlands National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: canyonlandsLogo,
        state: "Utah"
    },
    {
        name: "Capitol Reef National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: capitalReefLogo,
        state: "Utah"
    },
    {
        name: "Carlsbad Caverns National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: carlsbadCavernsLogo,
        state: "New Mexico"
    },
    {
        name: "Channel Islands National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: channelIslandLogo,
        state: "California"
    },
    {
        name: "Congaree National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: congareeLogo,
        state: "South Carolina"
    },
    {
        name: "Crater Lake National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: craterLakeLogo,
        state: "Oregon"
    },
    {
        name: "Cuyahoga Valley National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: cuyahogaValleyLogo,
        state: "Ohio"
    },
    {
        name: "Death Valley National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: deathValley,
        state: "California, Nevada"
    },
    {
        name: "Denali National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: denali,
        state: "Alaska"
    },
    {
        name: "Dry Tortugas National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: dryTortugasLogo,
        state: "Florida"
    },
    {
        name: "Everglades National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: everglades,
        state: "Florida"
    },
    {
        name: "Gates of the Arctic National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: gatesOfTheArctic,
        state: "Alaska"
    },
    {
        name: "Gateway Arch National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: gatewayArch,
        state: "Missouri"
    },
    {
        name: "Glacier Bay National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: glacierBay,
        state: "Alaska"
    },
    {
        name: "Glacier National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: glacier,
        state: "Montana"
    },
    {
        name: "Grand Canyon National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: grandCanyon,
        state: "Arizona"
    },
    {
        name: "Grand Teton National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: grandTeton,
        state: "Wyoming"
    },
    {
        name: "Great Basin National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: greatBasin,
        state: "Nevada"
    },
    {
        name: "Great Sand Dunes National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: greatSandDunes,
        state: "Colorado"
    },
    {
        name: "Great Smoky Mountains National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: smokyMountains,
        state: "Tennessee"
    },
    {
        name: "Guadalupe Mountains National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: guadalupeMountains,
        state: "Texas"
    },
    {
        name: "Haleakala National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: haleakala,
        state: "Hawaii"
    },
    {
        name: "Hawai'i Volcanoes National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: hawaiiVolcanoes,
        state: "Hawaii"
    },
    {
        name: "Hot Springs National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: hotsprings,
        state: "Arkansas"
    },
    {
        name: "Indiana Dunes National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: indianaDunes,
        state: "Indiana"
    },
    {
        name: "Isle Royale National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: isleRoyale,
        state: "Michigan"
    },
    {
        name: "Joshua Tree National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: joshuaTree,
        state: "California"
    },
    {
        name: "Katmai National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: katmai,
        state: "Alaska"
    },
    {
        name: "Kenai Fjords National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: kenaiFjords,
        state: "Alaska"
    },
    {
        name: "Kings Canyon National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: kingsCanyon,
        state: "California"
    },
    {
        name: "Kobuk Valley National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: kobukValley,
        state: "Alaska"
    },
    {
        name: "Lake Clark National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: lakeClark,
        state: "Alaska"
    },
    {
        name: "Lassen Volcanic National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: lassenVolcanic,
        state: "California"
    },
    {
        name: "Mammoth Cave National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: mammothCave,
        state: "Kentucky"
    },
    {
        name: "Mesa Verde National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: mesaVerde,
        state: "Colorado"
    },
    {
        name: "Mount Rainier National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: mountRanier,
        state: "Washington"
    },
    {
        name: "National Park of American Samoa",
        boundary: null,
        trails: null,
        grow: 1,
        logo: americanSamoaLogo,
        state: "American Samoa"
    },
    {
        name: "New River Gorge National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: newRiverGorge,
        state: "West Virginia"
    },
    {
        name: "North Cascades National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: northCascades,
        state: "Washington"
    },
    {
        name: "Olympic National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: olympic,
        state: "Washington"
    },
    {
        name: "Petrified Forest National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: petrifiedForest,
        state: "Arizona"
    },
    {
        name: "Pinnacles National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: pinnacles,
        state: "California"
    },
    {
        name: "Redwood National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: redwood,
        state: "California"
    },
    {
        name: "Rocky Mountain National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: rockyMountain,
        state: "Colorado"
    },
    {
        name: "Saguaro National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: saguaro,
        state: "Arizona"
    },
    {
        name: "Sequoia National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: sequoia,
        state: "California"
    },
    {
        name: "Shenandoah National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: shenandoah,
        state: "Virginia"
    },
    {
        name: "Theodore Roosevelt National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: theodoreRoosevelt,
        state: "North Dakota"
    },
    {
        name: "Virgin Islands National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: virginIslands,
        state: "U.S. Virgin Islands"
    },
    {
        name: "Voyageurs National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: voyageurs,
        state: "Minnesota"
    },
    {
        name: "White Sands National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: whiteSands,
        state: "New Mexico"
    },
    {
        name: "Wind Cave National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: windCave,
        state: "South Dakota"
    },
    {
        name: "Wrangell-St. Elias National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: wrangell,
        state: "Alaska"
    },
    {
        name: "Yellowstone National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: yellowStone,
        state: "Wyoming"
    },
    {
        name: "Yosemite National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: yosemite,
        state: "California"
    },
    {
        name: "Zion National Park",
        boundary: null,
        trails: null,
        grow: 1,
        logo: zion,
        state: "Utah"
    },
];

export const hasHikedTrail = (trips, TRLNAME, selectedNationalPark) => {
    let hasHikedTrail = false;
    trips.forEach(trip => {
        if (trip.activities?.some(activity => activity.categoryItemDetail1 === TRLNAME && activity.categoryItem === selectedNationalPark)) {
            hasHikedTrail = true
        }
    })
    return hasHikedTrail
}